import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs/Rx';
import { EventManager, ParseLinks, PaginationUtil, JhiLanguageService, AlertService, DateUtils } from 'ng-jhipster';


import { HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { ReservationFamilyResolvePagingParams } from './reservation-family.route';
import { ReservationFamilyService } from './reservation-family.service';
import { ReservationFamily, ReservationFamilyWithContextDetails } from './reservation-family.model';
import { LessonUtilService } from '../lesson';
import { CRUD_ACTIONS, FUZZY_SEARCH_DISTANCE, ITEMS_PER_PAGE } from '../../shared';
import { ClassTypeService, ClassType, ClassTypeUtilService} from '../class-type';
import { ReservationService } from '../reservation/reservation.service';

@Component({
    selector: 'jhi-reservation-family',
    templateUrl: './reservation-family.component.html'
})
export class ReservationFamilyComponent implements OnInit, OnDestroy {

    // variables for the recurrent reservations
    reservationFamilyList: ReservationFamily [];
    recurrentReservationsPage: any;
    recurrentReservationsPreviousPage: any;
    reservationFamilySubscription: Subscription;

    // variables for pagination
    links: any;
    totalItems: any;
    queryCount: any;
    itemsPerPage: any;
    page: any;
    predicate: any;
    previousPage: any;
    reverse: any;
    routeData: any;
    searchQuery: string;

    // variables for search
    currentSearchByStudentName: string;
    currentSearchByClassType: { id: number, name: string};
    classTypes: ClassType [];

    constructor(
        private jhiLanguageService: JhiLanguageService,
        private alertService: AlertService,
        private reservationFamilyService: ReservationFamilyService,
        private eventManager: EventManager,
        private parseLinks: ParseLinks,
        private activatedRoute: ActivatedRoute,
        private router: Router,
        private classTypeService: ClassTypeService,
        private classTypeUtilService: ClassTypeUtilService,
        private reservationService: ReservationService,
        private dateUtils: DateUtils
    ) {
        this.itemsPerPage = ITEMS_PER_PAGE;
        this.routeData = this.activatedRoute.data.subscribe((data) => {
            this.page = data['pagingParams'].page;
            this.previousPage = data['pagingParams'].page;
            this.reverse = data['pagingParams'].ascending;
            this.predicate = data['pagingParams'].predicate;
        });

        this.searchQuery = activatedRoute.snapshot.params['formattedSearch'] ?
                                        activatedRoute.snapshot.params['formattedSearch'] : '';

        if (this.searchQuery) {
            this.currentSearchByClassType = activatedRoute.snapshot.params['classType'];
            this.currentSearchByStudentName = activatedRoute.snapshot.params['studentLabel'] ?
            activatedRoute.snapshot.params['studentLabel'] : '';
        }

        this.jhiLanguageService.setLocations(['lesson', 'card', 'reservation-family']);
    }

    ngOnInit() {
        this.activatedRoute.params.subscribe((params) => {
                    this.loadReservationFamilies();
                });

        this.loadClassTypesList();

        this.registerChangeInReservationFamilies();
    }

    private loadClassTypesList() {
            this.classTypeService.search({query: 'active:true'})
            .subscribe(
                (res: HttpResponse<ClassType[]>) => {
                    if (!res.body) {
                        return;
                    }

                    this.classTypes = this.classTypeUtilService.orderClassTypesByName(res.body);
                },
                (res: HttpErrorResponse) => {
                    this.onError(res);
                }
            );
    }

    loadReservationFamilies() {
        const query: string = this.searchQuery ? this.searchQuery : '*';
        this.reservationFamilyService.search({
                query: query,
                size: this.itemsPerPage,
                sort: this.sort(),
                page: this.page - 1,
            })
            .subscribe(
                (res: HttpResponse<ReservationFamily[]>) => {
                    this.onReservationFamilySuccess(res.body, res.headers);
                },
                (res: HttpErrorResponse) => {
                    this.onError(res);
                });
    }

    search() {
        this.page = 0;
        this.searchQuery = this.getQuery();
        if ( !this.searchQuery ) {
            return this.clear();
        }
        let params = {
            formattedSearch: this.searchQuery,
            page: this.page,
            sort: this.predicate + ',' + (this.reverse ? 'asc' : 'desc')
        };

        if (this.currentSearchByStudentName) {
            params['studentLabel'] = this.currentSearchByStudentName;
        }

        this.router.navigate(['/reservation-family', params ]);
    }

    clear() {
        this.page = 0;
        this.currentSearchByStudentName = '';
        this.currentSearchByClassType = null;
        this.searchQuery = '';
        this.router.navigate(['/reservation-family', {
            page: this.page,
            sort: this.predicate + ',' + (this.reverse ? 'asc' : 'desc')
        }]);
    }

    getQuery(): string {
        let operators = [];

        if (this.currentSearchByClassType) {
            operators.push('lessonFamily.classType.id:' + this.currentSearchByClassType.id);
        }

        if (this.currentSearchByStudentName) {
            let formattedStudentName: string = this.currentSearchByStudentName.split(/[ ]+/)
                .reduce((acumQuery, token) => {
                    let fuzzyToken =  token !== '' ? token + '~' + FUZZY_SEARCH_DISTANCE : '';
                    return acumQuery + ' ' + fuzzyToken;
            }, '');
            operators.push('(student.user.firstName:' + formattedStudentName +
            ' OR ' + 'student.user.lastName:' + formattedStudentName + ')');
        }

        return operators.reduce((query, operator, i) => {
            query = query + operator + ((i < operators.length - 1) ? ' AND ' : '');
            return query;
        }, '');
    }

    sort() {
        let result = [this.predicate + ',' + (this.reverse ? 'asc' : 'desc')];

        return result;
    }

    loadPage(page: number) {
        if (page !== this.previousPage) {
            this.previousPage = page;
            this.transition();
        }
    }

    transition() {
        this.router.navigate(['/reservation-family'], {
            queryParams:
            {
                page: this.page,
                size: this.itemsPerPage,
                search: this.searchQuery,
                sort: this.predicate + ',' + (this.reverse ? 'asc' : 'desc')
            }
        });
        this.loadReservationFamilies();
    }

    onReservationFamilySuccess(data, headers) {
        this.links = this.parseLinks.parse(headers.get('link'));
        this.totalItems = headers.get('X-Total-Count');
        this.queryCount = this.totalItems;
        // this.page = pagingParams.page;

        this.reservationFamilyList = [];
        const reservationList = data;

        // loop the reservation family members to get the number of reservations
        reservationList.forEach(rf => {
            this.reservationService.countByReservationFamilyId(rf.id)
            .subscribe(
                (res: number) => {
                    let familyWithContextDetails: ReservationFamilyWithContextDetails =
                    ReservationFamilyWithContextDetails.fromReservationFamily(rf);
                    familyWithContextDetails.totalReservations = res;

                    this.reservationFamilyList.push(familyWithContextDetails);
                },
                (res: HttpErrorResponse) => {
                    this.onError(res);
                });

        });
    }

    getLessonFamilyStyle(reservationFamily: ReservationFamily) {
        let color =  LessonUtilService.getBackgroundColorForClassType(reservationFamily.lessonFamily.classType);
        return  {'color': color};
    }

    isSearchActive() {
        return this.currentSearchByStudentName  || this.currentSearchByClassType ;
    }

    ngOnDestroy() {
        this.eventManager.destroy(this.reservationFamilySubscription);
    }

    registerChangeInReservationFamilies() {
        this.reservationFamilySubscription = this.eventManager
            .subscribe('reservationFamilyListModification',
                (response) => this.handleActionResult(response.content));
    }

    previousState() {
        window.history.back();
    }

    private onError(error) {
        this.alertService.error(error.message, null, null);
    }

    private handleActionResult(result: { action: string, content: any }) {
        let entity: ReservationFamily = result.content;
        let action: String = result.action;

        this.reservationFamilyList.forEach((item, i) => {
                if (item.id === entity.id) {
                    switch (action) {
                        case CRUD_ACTIONS.UPDATE:
                            // we have to format the entity before swaping
                            entity.startDate = this.dateUtils
                                            .convertDateTimeFromServer(entity.startDate);
                            entity.endDate = this.dateUtils
                                            .convertDateTimeFromServer(entity.endDate);

                            this.reservationFamilyList[i] = entity;
                            break;
                        case CRUD_ACTIONS.DELETE:
                            this.reservationFamilyList.splice(i, 1);
                            break;
                    }
                }
            });
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/reservation-family/reservation-family.component.ts